import { CircularProgress } from "@mui/material"

export const LoadingSpinner = (props: any) => <CircularProgress {...props} />
